





























import {
  defineComponent,
  computed,
  onMounted,
  ref,
  useStore,
} from '@nuxtjs/composition-api'
import BlockButtonsItem from '@/components/BlockButtonsItem.vue'

const LOCAL_STORAGE_TTL_KEY = 'mobile-banner-closed-ttl'

export default defineComponent({
  name: 'MobileAppBanner',
  components: { BlockButtonsItem },
  setup() {
    const store = useStore()
    const os = computed(() => {
      const value = store.getters['userAgent/os'] || ''
      return value.toLowerCase()
    })
    const banner = computed(() => {
      const value = store.getters['settings/getMobileAppBanner']?.[os.value]
      if (!value?.text) return null
      return value
    })
    const isClosed = ref(true)
    const onClose = () => {
      isClosed.value = true
      const expires = Date.now() + 3 * 24 * 60 * 60 * 1000
      localStorage.setItem(LOCAL_STORAGE_TTL_KEY, String(expires))
    }
    onMounted(() => {
      const expires = Number(localStorage.getItem(LOCAL_STORAGE_TTL_KEY)) || 0
      const expired = Date.now() > expires
      isClosed.value = !expired
      if (expired) localStorage.removeItem(LOCAL_STORAGE_TTL_KEY)
    })

    return {
      onClose,
      isClosed,
      banner,
    }
  },
})
